import React from "react";
import { FormRow } from "./FormRow";

interface GroupSelectProps {
  label: string;
  groups: { id: number; name: string }[];
  value: number;
  onChange: (value: number) => void;
}

export const GroupSelect: React.FC<GroupSelectProps> = ({
  label,
  groups,
  value,
  onChange,
}) => {
  return (
    <div className="flex formRow">
      <div className="fieldName">{label}</div>
      <div className="fieldInput flex">
        <select
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
        >
          {groups.map((group) => (
            <option key={group.id} value={group.id}>
              {group.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};